import React from "react";
import {
  MobileActionSheet,
  MobileActionSheetProps
} from "@cmp-src/mobile/MobileActionSheet/MobileActionSheet";
import { useReserve } from "@/features/reserve/providers/context";
import { useTranslation } from "react-i18next";

export const MobileGlobalReserveActionSheet: React.FC<
  Omit<MobileActionSheetProps, "actions">
> = (props) => {
  const { openReserveModal } = useReserve();
  const { t } = useTranslation("common");

  const handleReserveRoom = () => {
    openReserveModal({
      resourceType: "meeting_room"
    });
  };

  const handleReserveDesk = () => {
    openReserveModal({
      resourceType: "desk"
    });
  };

  return (
    <MobileActionSheet
      title="Choose a resource type"
      message="Select the type of resource you want to reserve."
      {...props}
      actions={[
        { label: t("navActions.reserveRoom"), onSelect: handleReserveRoom },
        { label: t("navActions.reserveDesk"), onSelect: handleReserveDesk }
      ]}
    />
  );
};
